import Vue from 'vue';
import Vuex from 'vuex';

import {
  headerDetails, loginDetails, tenantDetails, appsDetails, usersDetails,
  epBaseDetails, advancedSearchDetails
} from './modules';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    headerDetails, loginDetails, tenantDetails, appsDetails, usersDetails, advancedSearchDetails,
    epBaseDetails
  },
});
